// Input.js
import React, { forwardRef } from "react";
import DatePicker from '../DatePicker';
import dayjs from 'dayjs';

const Input = forwardRef(function InputComponent(props, ref) {
  if (props.type === 'date') {
    const handleDatePickerChange = (date) => {
      if (props.inputchangehandler) {
        const formattedDate = date ? dayjs(date).format('YYYY-MM-DD') : '';
        props.inputchangehandler(formattedDate);
      }
    };

    const minDate = props.min ? dayjs(props.min).toDate() : undefined;

    return (
      <DatePicker
        ref={ref}
        className={props.className}
        placeholder={props.placeholder || "Select date"}
        onChange={handleDatePickerChange}
        value={props.value || null}
        disabled={props.disabled || props.readOnly}
        minDate={minDate}
        name={props.name}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
      />
    );
  }

  const classes =
    "input px-3 input-shadow text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline " +
    props.className;

  const handleKeyDown = (e) => {
    if (props.type === "number" && ["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <input
      ref={ref}
      className={classes}
      placeholder={props.placeholder || " "}
      onChange={(e) => {
        if (props?.inputchangehandler) {
          props.inputchangehandler(e?.target?.value);
        }
        if (props?.onChange) {
          props.onChange(e);
        }
      }}
      value={props?.value}
      name={props?.name}
      checked={props?.checked}
      readOnly={props?.readOnly}
      disabled={props?.disabled}
      onBlur={props?.onBlur}
      maxLength={props?.maxLength}
      type={props?.type}
      onKeyDown={handleKeyDown}
    />
  );
});

export default Input;
